import { Slot } from '@radix-ui/react-slot';
import {
  formField,
  FormFieldVariantProps,
} from '@repo/themes/styled-system/recipes';
import { FormFieldVariant } from '@repo/themes/styled-system/recipes';
import React from 'react';
import { ComponentProps } from 'react';

const classes = formField();

const FormField = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <div className={classes.root}>{children}</div>;
};

export interface FormFieldLabelProps
  extends Partial<FormFieldVariant>,
    ComponentProps<'label'> {}

const Label = ({
  children,
  ...allProps
}: FormFieldLabelProps): React.JSX.Element => {
  const [labelProps, props] = formField.splitVariantProps(allProps);
  const classes = formField(labelProps);

  return (
    <label className={classes.label} {...props}>
      {children}
    </label>
  );
};

const Message = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <p className={classes.message}>{children}</p>;
};

const FormControl = (props: FormFieldVariantProps) => {
  return <Slot {...props}></Slot>;
};

FormField.displayName = 'FormField.Container';
Label.displayName = 'FormField.Label';
Message.displayName = 'FormField.Message';
FormControl.displayName = 'FormField.Control';

export default {
  Container: FormField,
  Label: Label,
  Message: Message,
  Control: FormControl,
};
